import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ShopCollections.css';

const collections = [
  {
    id: 'engagement',
    title: 'Engagement Rings',
    description: 'Timeless symbols of love and commitment',
    image: '/images/engagement-collection.jpg',
    priceRange: '$2,000 - $50,000'
  },
  {
    id: 'anniversary',
    title: 'Anniversary Gifts',
    description: 'Celebrate your journey together',
    image: '/images/anniversary-collection.jpg',
    priceRange: '$1,500 - $30,000'
  },
  {
    id: 'classic',
    title: 'Classic Collection',
    description: 'Timeless designs that never go out of style',
    image: '/images/classic-collection.jpg',
    priceRange: '$3,000 - $40,000'
  },
  {
    id: 'modern',
    title: 'Modern Collection',
    description: 'Contemporary designs for the modern couple',
    image: '/images/modern-collection.jpg',
    priceRange: '$2,500 - $45,000'
  },
  {
    id: 'vintage',
    title: 'Vintage Collection',
    description: 'Heirloom-inspired pieces with timeless elegance',
    image: '/images/vintage-collection.jpg',
    priceRange: '$3,500 - $55,000'
  },
  {
    id: 'custom',
    title: 'Custom Designs',
    description: 'Create your perfect piece with our expert guidance',
    image: '/images/custom-collection.jpg',
    priceRange: 'Custom Pricing'
  }
];

const ShopCollections = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="shop-collections">
      <div className="collections-header">
        <h1>Our Collections</h1>
        <p>Discover our carefully curated selection of fine jewelry</p>
      </div>

      <div className="collections-grid">
        {collections.map(collection => (
          <div key={collection.id} className="collection-card">
            <div className="collection-image">
              <img src={collection.image} alt={collection.title} />
              <div className="collection-overlay">
                <Link to={`/quiz?collection=${collection.id}`} className="view-collection">
                  View Collection
                </Link>
              </div>
            </div>
            <div className="collection-info">
              <h3>{collection.title}</h3>
              <p>{collection.description}</p>
              <span className="price-range">{collection.priceRange}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="collections-cta">
        <h2>Can't Find What You're Looking For?</h2>
        <p>Let us help you find or create your perfect piece</p>
        <Link to="/contact" className="cta-button">Contact Us</Link>
      </div>
    </div>
  );
};

export default ShopCollections; 